module.exports = __webpack_public_path__ + "noaa-logo.6c3e0d0f.png";